import { Heading } from '@clayui/core';
import ClayLayout from '@clayui/layout';
import React from 'react';

const FinalScreen: React.FC<{
    resStatusMessage: string;
    resStatusCode: number;
}> = ({ resStatusMessage, resStatusCode }) => {
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 1000);
        return () => clearTimeout(timeout);
    }, []);
    return resStatusCode === 200 ? (
        <>
            <ClayLayout.ContentSection className="final_screen">
                <div className="success_icon">
                    <svg
                        width="51"
                        height="51"
                        viewBox="0 0 41 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.6686 33.4921L0.442383 20.2658L6.4698 14.2384L13.6686 21.4585L34.7113 0.394531L40.7387 6.42195L13.6686 33.4921Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div
                    className="mt-5"
                    style={{ color: '#76BC21', textAlign: 'center' }}
                >
                    <Heading level={1} weight="bold" fontSize={6}>
                        Thank You!
                    </Heading>
                    <Heading level={6} weight="normal" fontSize={5}>
                        {/* {resStatusMessage}         */}
                        Form submitted successfully!
                    </Heading>
                </div>
            </ClayLayout.ContentSection>
        </>
    ) : (
        <>
            <ClayLayout.ContentSection className="final_screen">
                <div className="error_icon">
                    <svg
                        width="51"
                        height="51"
                        viewBox="0 0 71 71"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M35.4997 0.5C54.8264 0.5 70.4999 16.1735 70.4999 35.5002C70.4999 54.8269 54.8264 70.5004 35.4997 70.5004C16.173 70.5004 0.499512 54.8269 0.499512 35.5002C0.499512 16.1735 16.173 0.5 35.4997 0.5ZM31.75 38.512V20.4978C31.75 18.4327 33.4346 16.7481 35.4997 16.7481C37.5649 16.7481 39.2494 18.4483 39.2494 20.4978V38.512C39.2494 40.5615 37.5649 42.2617 35.4997 42.2617C33.4346 42.2617 31.75 40.5771 31.75 38.512ZM35.4835 46.2834C37.8303 46.2834 39.7337 48.1867 39.7337 50.5333C39.7337 52.8801 37.8303 54.7835 35.4835 54.7835C33.137 54.7835 31.2336 52.8801 31.2336 50.5333C31.2336 48.1867 33.137 46.2834 35.4835 46.2834Z"
                            fill="#F9F9F9"
                        />
                    </svg>
                </div>
                <div
                    className="error-section mt-5"
                    style={{ color: '#DA1414', textAlign: 'center' }}
                >
                    <Heading level={1} weight="bold" fontSize={6}>
                        Sorry!
                    </Heading>
                    <Heading level={6} weight="normal" fontSize={5}>
                        {resStatusMessage}
                    </Heading>
                </div>
            </ClayLayout.ContentSection>
        </>
    );
};

export default FinalScreen;
